import type { FC } from 'react'

import style from '@/pages/tad.ai/_components/H2/index.module.scss'

import { cls } from 'tagged-classnames-free';
/**
 * @returns The H1 component.
 */
export const H1: FC<React.HTMLAttributes<HTMLHeadingElement>> = (props) => {
  const { children, className, ...rest } = props
  return (
    <h1
      className={cls`text-4xl font-bold lg:text-[56px] lg:leading-[64px] ${style.heightLightText} ${className}`}
      {...rest}
    >
      {children}
    </h1>
  )
}
